var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomInput',_vm._g(_vm._b({staticClass:"sms-code-component",attrs:{"value":_vm.value,"inputmode":"numeric","autocomplete":"one-time-code","minlength":"4","maxlength":"4","label":"Код"}},'CustomInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }